import {
  SegmentedControl as MantineSegmentedControl,
  SegmentedControlProps,
} from "@mantine/core"
import { forwardRef, ReactNode } from "react"

import styles from "./SegmentedControl.module.css"

export interface CustomSegmentedControlProps extends Omit<
  SegmentedControlProps,
  "onChange"
> {
  onChange?: (value: string) => void
  data: { label: string | ReactNode; value: string; disabled?: boolean }[]
}

export const SegmentedControl = forwardRef<
  HTMLDivElement,
  CustomSegmentedControlProps
>(({ onChange, classNames, ...props }, ref) => {
  return (
    <MantineSegmentedControl
      ref={ref}
      onChange={onChange}
      transitionDuration={100}
      classNames={{
        root: `${styles.segmentedControl}`,
        label: `${styles.segmentedControlLabel}`,
        ...classNames,
      }}
      {...props}
    />
  )
})

SegmentedControl.displayName = "SegmentedControl"
